import React, { ChangeEvent, FC, useMemo } from 'react'
import { EditorState } from 'draft-js'
import { PriceForm, SelectBox, WysiwygEditor } from 'components/Form'
import { Spacer } from 'components/Utility'
import { FormLabel } from 'components/Label'
import { CategoryType } from 'types/category'

type Props = {
  storeDefaultId: string
  storeId: string
  categories: CategoryType[]
  categoryId: string
  currentDescriptionLength: number
  description: EditorState | undefined
  handleDescription: (editorState: EditorState) => void
  handlePrice: (event: ChangeEvent<HTMLInputElement>) => void
  price: number
  replaceImage: (src: string, dist: string) => void
  selectCategoryName: (value: string) => void
}

const ProductDefaultBaseSection: FC<Props> = React.memo((props) => {
  const {
    storeDefaultId,
    storeId,
    categories,
    categoryId,
    currentDescriptionLength,
    description,
    handleDescription,
    handlePrice,
    price,
    replaceImage,
    selectCategoryName,
  } = props

  const categoryOptions = useMemo(() => {
    if (!categories || categories.length === 0) return [{ label: '', value: '' }]

    return categories.map((category) => {
      return { label: category.name, value: category.category_ref.id }
    })
  }, [categories])

  return (
    <>
      <FormLabel id={'description'} label={'商品説明'} required={true} />
      <Spacer size={8} />
      <WysiwygEditor
        currentLength={currentDescriptionLength}
        editorState={description}
        folderPath={`stores/${storeId}/store_defaults/${storeDefaultId}/description`}
        maxLength={3000}
        onEditorStateChange={handleDescription}
        replaceImage={replaceImage}
      />
      <Spacer size={56} />
      <FormLabel id={'category'} label={'商品カテゴリー'} required={true} />
      <Spacer size={8} />
      <SelectBox options={categoryOptions} select={selectCategoryName} value={categoryId} />
      <Spacer size={28} />
      <PriceForm handlePrice={handlePrice} id={'price'} isRequired={false} price={price} />
    </>
  )
})

export default ProductDefaultBaseSection
